import { Component, Inject } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilService } from 'src/app/core/services/util.service';
import { TeachingFieldService } from 'src/app/core/services/teaching-field.service';

@Component({
  selector: 'app-teaching-field',
  templateUrl: './teaching-field.component.html',
  styleUrl: './teaching-field.component.scss'
})
export class TeachingFieldComponent {
  action: 'add' | 'edit' = 'add';
  rowData: any = null;

  userForm: FormGroup = new FormGroup({});
  formFields = [
    { name: 'id', label: 'ID', type: 'text', space: 0},
    { name: 'name', label: 'Name', type: 'text', space: 1, validators: [Validators.required]},
    { name: 'gradeLevel', label: 'Grade Level', type: 'text', space: 1, validators: [Validators.required]},
    { name: 'displayName', label: 'Display Name', type: 'text', space: 1, validators: [Validators.required]},
    { 
      name: 'category', label: 'Category', type: 'select', space: 1, validators: [Validators.required], 
      options: this.teachingFieldService.categoriesList.map((i: any) => ({ label: i, value: i }))
    }
  ];
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<TeachingFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public teachingFieldService: TeachingFieldService,
    private utilService: UtilService
  ) {
    this.action = data?.action || 'add';
    this.rowData = data?.data || null;
  }

  ngAfterViewInit() {
    if (this.action === 'edit' && this.rowData) {
      this.rowData.OpenDate = new Date(this.rowData.OpenDate);
      this.rowData.CloseDate = new Date(this.rowData.CloseDate);
      setTimeout(() => {
        this.userForm.patchValue(this.rowData);
      });
    }
  }

  async submit() {
    if (!this.userForm.valid) return;
    this.submitting = true;
    this.addEdit(this.userForm.getRawValue()).subscribe({
      next: () => {
        this.utilService.openToastrCrud('Teaching field', this.action, 'success');
        this.dialogRef.close(true);
      },
      error: () => {
        this.utilService.openToastrCrud('Teaching field', this.action, 'error');
        this.submitting = false;
      }
    })
  }

  addEdit(payload: any) {
    if (this.action === 'add') {
      return this.teachingFieldService.createTeachingField(payload)
    } else {
      return this.teachingFieldService.updateTeachingField({ ...payload, active: this.rowData?.active })
    }
  }
}
